<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-md-4">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted" style="font-size: 12px">Matured Savings(KES)</h6>
                  <span class="h4 font-weight-bold">{{stats.total_matured_savings}}</span>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="card_green  mr-2"><i class="icon-arrow-top-right"></i> 3.48%</span>
                <span class="text-nowrap">Compared to last month</span>
              </p>
              <hr>
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted" style="font-size: 12px">Number of active Savings</h6>
                  <span class="h4 font-weight-bold">0</span>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="card_green  mr-2"><i class="icon-arrow-top-right"></i>  3.48%</span>
                <span class="text-nowrap">Compared to last month</span>
              </p>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-12">
          <px-card>
            <div slot="with-padding">
              <div class="row">
                <div class="col-md-2">
                  <h5>Matured Savings</h5>
                </div>
                <div class="col-md-4">
                  <b-input-group class="border rounded-pill p-1">
                    <div class="input-group-prepend border-0">
                      <button id="button-addon4" type="button" class="btn btn-link text-info"><i class="fa fa-search"></i></button>
                    </div>
                    <b-form-input
                        v-model="searchTitle"
                        placeholder="Type to Search"
                        aria-describedby="button-addon4"
                        class="form-control bg-none border-0"
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <VueDatePicker
                            v-model="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            placeholder="Select Date Range"
                            class="form-control"
                            range
                            fullscreen-mobile
                            validate
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <button class="btn btn-primary" @click="generateExcel()" :disabled="!date">Export Excel</button>
                    </div>
                  </div>
                </div>

              </div>
              <div class="table-responsive datatable-vue">
                <b-table
                    striped hover
                    :items="matured.data"
                    :fields="fields"
                    :per-page="perPage"
                >
                </b-table>
              </div>

              <b-col md="6" class="mt-3 p-0">
                <b-pagination v-if="matured.data && matured.data.length >= 1"
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                              @change="handlePageChange"
                              class="my-0"
                ></b-pagination>
                <div class="text-center" v-else>
                  No Records Found
                </div>
              </b-col>
            </div>
          </px-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getRequestParams} from "@/helpers/pagination";
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import axios from "axios";
import {withdrawal_matured_field_defs} from "@/pages/withdrawals/fields/withdrawal_matured_field_defs";
export default {
  components: {VueDatePicker},
  data() {
    return {
      fields: withdrawal_matured_field_defs,
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 50, 100],
      searchTitle: "",
      date: "",
      currentDate: new Date(),
      date_from:'',
      date_to:'',
      total:0
    }
  },
  mounted() {
    this.retrieveMatured();
    this.$store.dispatch('updateStats');
  },
  computed:{
    ...mapGetters({matured:'getMatured',stats:'getStats'}),
    minDate () {
      return new Date(
          this.currentDate.getFullYear() - 1,
          this.currentDate.getMonth(),
          this.currentDate.getDate()
      );
    },
    maxDate () {
      return new Date(
          this.currentDate.getFullYear() + 1,
          this.currentDate.getMonth(),
          this.currentDate.getDate(),
      );
    },
  },
  watch: {
    matured() {
      this.totalRows = this.matured.meta.total;
    },
    searchTitle() {
      this.retrieveMatured();
    },
    date() {
      this.date_from  = this.date.start;
      this.date_to  = this.date.end;
      this.retrieveMatured();
    }
  },
  methods:{
    retrieveMatured() {
      const params = getRequestParams(
          this.searchTitle,
          this.currentPage,
          this.perPage
      );
      this.$store.dispatch('updateMatured',params)
    },
    handlePageChange(value) {
      this.currentPage = value
      this.retrieveMatured();
    },
    generateExcel() {
      const formData = {date_from:this.date.start,date_to:this.date.end}
      axios.post('withdrawal/matured-export',formData)
          .then((res) =>{
          })
    },
  }
}
</script>

<style scoped>
.form-control:focus {
  box-shadow: none;
}

.form-control-underlined {
  border-width: 0;
  border-bottom-width: 1px;
  border-radius: 0;
  padding-left: 0;
}

.card {
  box-shadow: 7px 7px 7px 7px rgba(50, 50, 50, 0.5) !important;
}
.card_green {
  color: #63D926 !important;
}
</style>
